export default {
      id: "action-icon-sensitive-request-usage",
      viewBox: "0 0 30 31",
      url: __webpack_public_path__ + "icons.svg#action-icon-sensitive-request",
      toString: function () {
        return this.url;
      }
    }